export default "__VITE_ASSET__fPx2pNJS__"